module.exports = require('../full/is-iterable');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/features/is-iterable.js
// module id = 616
// module chunks = 0 1